import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

/**
 * Universal modal layout for consistent header/content/footer structure.
 *
 * Usage:
 * <UniversalModal
 *   open={open}
 *   onClose={onClose}
 *   title="My Title"
 *   headerRight={<IconButton ... />}
 *   footer={<Button ... />}
 * >
 *   ...content...
 * </UniversalModal>
 */
const UniversalModal = ({
  open,
  onClose,
  title,
  headerRight,
  header,
  children,
  footer,
  maxWidth = 'sm',
  fullWidth = true,
  fullScreen,
  paperProps,
  dialogProps,
  contentDividers = false,
  titleSx,
  contentSx,
  actionsSx,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      PaperProps={paperProps}
      {...dialogProps}
    >
      {header ? (
        <DialogTitle sx={{ ...titleSx }}>{header}</DialogTitle>
      ) : (title || headerRight) ? (
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: headerRight ? 'space-between' : 'flex-start',
            gap: 1,
            ...titleSx,
          }}
        >
          {title}
          {headerRight}
        </DialogTitle>
      ) : null}

      <DialogContent dividers={contentDividers} sx={contentSx}>
        {children}
      </DialogContent>

      {footer ? <DialogActions sx={actionsSx}>{footer}</DialogActions> : null}
    </Dialog>
  );
};

export default UniversalModal;

